import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

interface ArticleCardProps {
  id: string;
  slug: string;
  title: string;
  excerpt: string;
  category: string;
  image: string;
  author: string;
  authorAvatar: string;
  date: string;
  readTime: string;
  tags: string[];
  featured?: boolean;
}

export default function ArticleCard({
  slug,
  title,
  excerpt,
  category,
  image,
  author,
  authorAvatar,
  date,
  readTime,
  tags,
  featured,
}: ArticleCardProps) {
  const cat = categories.find(c => c.slug === category);

  return (
    <article className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer">
      <Link to={`/article/${slug}`} className="block">
        <div className="relative overflow-hidden aspect-[16/10]">
          <img
            src={image}
            alt={title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
          {featured && (
            <span className="absolute top-3 left-3 px-2.5 py-1 text-xs font-medium bg-primary-500 text-background-50 rounded-full whitespace-nowrap">
              精选
            </span>
          )}
          <div className="absolute bottom-3 left-3">
            <span className={`px-2.5 py-1 text-xs font-medium rounded-full whitespace-nowrap ${
              cat?.color === 'accent'
                ? 'bg-accent-500/90 text-background-50'
                : 'bg-primary-500/90 text-background-50'
            }`}>
              {cat?.name}
            </span>
          </div>
        </div>
        <div className="p-5">
          <h3 className="text-base font-bold font-heading text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors duration-200 leading-snug">
            {title}
          </h3>
          <p className="text-sm text-foreground-500 leading-relaxed mb-4 line-clamp-2">
            {excerpt}
          </p>
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <img
                src={authorAvatar}
                alt={author}
                className="w-7 h-7 rounded-full object-cover"
              />
              <span className="text-xs text-foreground-500 whitespace-nowrap">{author}</span>
            </div>
            <div className="flex items-center gap-3 text-xs text-foreground-400">
              <span className="whitespace-nowrap">{date}</span>
              <span className="whitespace-nowrap">{readTime}</span>
            </div>
          </div>
        </div>
      </Link>
    </article>
  );
}